import { bundleUrl } from "@metablock/core";

const light = bundleUrl("metablock-light.svg");
const dark = bundleUrl("metablock-dark.svg");
const avatarDark = bundleUrl("metablock-avatar-dark.svg");

export default { light, dark, avatarDark };
